/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSaveApplyRequest,
  TSaveApplyModel,
  IMappers,
  TSaveApplyResponse_,
  TSaveApplyResponse,
  TSaveApplyResponse_1,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSaveApplyModel(parameters: TSaveApplyRequest): TSaveApplyModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'job-vacancies-backend',
    pathApi: '/v2/save-apply/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export const defaultConfig = createSaveApplyModel({} as unknown as TSaveApplyRequest);

export interface ISaveApplyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSaveApplyRequest;
}

export async function fetchSaveApply<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISaveApplyOptions<TResponse200, TResponse400>): Promise<TSaveApplyResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSaveApplyModel(parameters),
    config,
  )) as FetchResponse<TSaveApplyResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSaveApplyResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TSaveApplyResponse;
}
